import React from "react";
import styled from "styled-components";

function BlogSmallBox({ image, title, week, date, path }) {
  return (
    <Container>
      <a className="newsletter_link" href={path && `/newsletter/${path}`}>
        <div className="image">
          <img src={`/image/banners/${image}`} alt="" />
        </div>
        <div className="details">
          <div className="title">{title}</div>
          <div className="week">{week && `Week - ${week}`}</div>
          <div className="date">{date && `Date: ${date}`}</div>
        </div>
      </a>
    </Container>
  );
}

const Container = styled.section`
  border-radius: 10px;
  box-shadow: var(--box-shadow);
  width: min(100%, 280px);
  margin: 0 auto;
  text-align: left;
  a.newsletter_link {
    text-decoration: none;
    color: var(--text-color);
  }
  .image {
    img {
      border-radius: 10px 10px 0 0;
      width: 100%;
      object-fit: cover;
    }
  }
  .details {
    padding: 5px 20px 10px;
    .title {
      font-size: var(--normal-text);
    }
    .week {
      font-size: var(--xSmall-text);
    }
    .date {
      font-size: var(--vSmall-text);
    }
  }
`;

export default BlogSmallBox;
